<template>
    <modal title-modal="Índices de Correção Monetária" modal-xl id-modal="config-monetary-modal">
        <template #title>Índices de Correção Monetária</template>

        <div class="modal-body">
            <div class="row gutters align-items-end" v-if="!disableInputs">
                <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                    <div class="form-group">
                        <label>Índice de Correção Monetária:</label>
                        <select2 :settings="{width: '100%'}"
                                 placeholder="Selecione"
                                 v-model="selectedIndex"
                                 :options="optionsMonetary"/>
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-4 col-sm-4 col-6">
                    <div class="form-group">
                        <label>Limite Mínimo (%):</label>
                        <input type="text" class="form-control text-center"
                               v-model="readjustLimitMin" v-money3="limitMask">
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-4 col-sm-4 col-6">
                    <div class="form-group">
                        <label>Limite Máximo (%):</label>
                        <input type="text" class="form-control text-center"
                               v-model="readjustLimitMax" v-money3="limitMask">
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-4 col-sm-4 col-12">
                    <div class="form-group d-flex justify-content-center">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" id="readjust_auto_new"
                                   v-model="readjustAuto">
                            <label class="custom-control-label" for="readjust_auto_new">Reaj. Auto</label>
                        </div>
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12">
                    <div class="form-group">
                        <button class="btn btn-primary w-100" @click.prevent="addIndex">
                            Adicionar
                        </button>
                    </div>
                </div>
            </div>
            <div class="table-responsive" v-if="indexes.length">
                <table class="table table-bordered table-striped m-0">
                    <thead>
                    <tr>
                        <th>Índice</th>
                        <th class="text-center" style="width: 140px">Limite Mínimo (%)</th>
                        <th class="text-center" style="width: 130px">Limite Máximo (%)</th>
                        <th class="text-center" style="width: 110px">Reaj. Auto</th>
                        <th class="text-center" style="width: 110px">Padrão</th>
                        <th class="text-center" style="width: 90px" v-if="!disableInputs">Ações</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, key) in indexes" :key="item.monetary_correction_index_id">
                        <td>{{ item.label }}</td>
                        <td class="text-center">
                            <input type="text"
                                   class="form-control form-control-sm text-center"
                                   :disabled="disableInputs"
                                   v-model="item.readjust_limit_min"
                                   v-money3="limitMask">
                        </td>
                        <td class="text-center">
                            <input type="text"
                                   class="form-control form-control-sm text-center"
                                   :disabled="disableInputs"
                                   v-model="item.readjust_limit"
                                   v-money3="limitMask">
                        </td>
                        <td class="text-center">
                            <div class="custom-control custom-switch d-inline-block">
                                <input type="checkbox"
                                       class="custom-control-input"
                                       :id="`monetary_auto_${key}`"
                                       :disabled="disableInputs"
                                       v-model="item.readjust_auto">
                                <label class="custom-control-label" :for="`monetary_auto_${key}`"/>
                            </div>
                        </td>
                        <td class="text-center">
                            <div class="custom-control custom-switch d-inline-block">
                                <input type="checkbox"
                                       class="custom-control-input"
                                       :id="`monetary_default_${key}`"
                                       :disabled="disableInputs"
                                       v-model="item.default"
                                       @change="changeDefault(key)">
                                <label class="custom-control-label" :for="`monetary_default_${key}`"/>
                            </div>
                        </td>
                        <td class="text-center" v-if="!disableInputs">
                            <i v-if="item.monetary_correction_index_id !== nullIndexId"
                               class="icon-trash pointer"
                               @click="removeIndex(key)"
                               title="Remover"></i>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="text-center text-muted" v-else>
                Nenhum índice vinculado a esta configuração.
            </div>
        </div>

        <div class="modal-footer" style="justify-content: space-between">
            <div class="btn btn-secondary" data-dismiss="modal" id="closeMonetary" @click="closeModal">{{
                    t('ACTIONS.CLOSE')
                }}
            </div>
            <div class="btn btn-primary ml-2" @click="save" v-if="!disableInputs">{{ t('ACTIONS.SAVE') }}</div>
        </div>
    </modal>
</template>

<script>

import {useI18n} from 'vue-i18n';
import modal from '@/components/modal.vue';
import Select2 from 'vue3-select2-component';
import {Money3Directive} from 'v-money3';
import {useToast} from 'vue-toastification';

export default {
    name: 'configMonetaryCorrectionComponent',

    emits: ['updateMonetaryIndexes'],

    directives: {
        money3: Money3Directive,
    },

    setup() {
        const {t} = useI18n();
        const toast = useToast();

        return {t, toast};
    },

    props: {
        disableInputs: {
            type: Boolean,
            default: false,
        },
        optionsMonetary: {
            type: Array,
            default: () => [],
        },
        nullIndexId: {
            type: Number,
            default: null,
        },
    },

    components: {
        modal,
        Select2,
    },

    data() {
        return {
            indexes: [],
            selectedIndex: null,
            readjustLimitMax: 0,
            readjustLimitMin: 0,
            readjustAuto: false,
            limitMask: {
                max: 100,
                precision: 2,
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: ' %',
                masked: false,
                allowBlank: true,
            },
        };
    },

    methods: {
        setIndexes(simulatorConfig) {
            this.selectedIndex = null;
            this.readjustLimitMax = 0;
            this.readjustLimitMin = 0;
            this.readjustAuto = false;
            this.indexes = (simulatorConfig.monetary_correction_indexes ?? []).map(item => ({
                ...item,
                readjust_auto: item.readjust_auto ?? false,
                readjust_limit: item.readjust_limit ?? 0,
                readjust_limit_min: item.readjust_limit_min ?? 0,
            }));
        },

        addIndex() {
            if (!this.selectedIndex || this.selectedIndex === 'selecione') return;

            const alreadyAdded = this.indexes.some(item => item.monetary_correction_index_id == this.selectedIndex);
            if (alreadyAdded) {
                this.toast.warning('Índice já vinculado a esta configuração.');
                return;
            }

            const option = this.optionsMonetary.find(item => item.id == this.selectedIndex);
            this.indexes.push({
                monetary_correction_index_id: this.selectedIndex,
                label: option?.text ?? this.selectedIndex,
                sort_order: this.indexes.length + 1,
                default: !this.indexes.length,
                readjust_auto: this.readjustAuto,
                readjust_limit: this.readjustLimitMax ?? 0,
                readjust_limit_min: this.readjustLimitMin ?? 0,
            });
            this.selectedIndex = null;
            this.readjustLimitMax = 0;
            this.readjustLimitMin = 0;
            this.readjustAuto = false;
        },

        removeIndex(key) {
            this.indexes.splice(key, 1);
            this.indexes.forEach((item, index) => item.sort_order = index + 1);
        },

        changeDefault(key) {
            if (!this.indexes[key].default) return;
            this.indexes.forEach((item, index) => item.default = index === key);
        },

        closeModal() {
            document.getElementById('closeMonetary')?.click();
        },

        save() {
            if (this.$route.params.action !== 'adicionar') {
                this.$swal.fire({
                    title: 'Tem Certeza?',
                    text: 'A alteração será aplicada imediatamente.',
                    icon: 'question',
                    showCancelButton: true,
                    showCloseButton: false,
                    confirmButtonText: 'Atualizar',
                    cancelButtonText: 'Cancelar',
                }).then(result => {
                    if (result.isConfirmed) this.$emit('updateMonetaryIndexes', this.indexes);
                });
            } else this.$emit('updateMonetaryIndexes', this.indexes);
        },
    },
};

</script>
